import { useState, useEffect } from "react";
import { storage } from "@/helper/storage";

export function useLoadAuth() {
    const [token, setToken] = useState<string | null>(null);
    const [user, setUser] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const load = async () => {
            try {
                const storedToken = await storage.getItem("token");
                const storedUser = await storage.getItem("user");

                if (!isMounted) return;

                if (storedToken) setToken(storedToken);
                if (storedUser) setUser(JSON.parse(storedUser));
            } catch (e) {
                console.error("Error loading auth:", e);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        load();

        return () => { isMounted = false; };
    }, []);

    return { token, user, loading, setToken, setUser };
}
